import React, { useState,useEffect } from 'react';
import { Link, Route,Routes} from 'react-router-dom';
import BottomTab from './BottomTab';
import axios from 'axios';
import Api from "../Api/Api.json";
import { Capacitor } from "@capacitor/core";

// Conditionally import BPPlugin only on native platforms
let BPPlugin = null;
if (Capacitor.isNativePlatform()) {
  const BPPluginModule = require("../BPPlugin");
  BPPlugin = BPPluginModule.default;
}

const items = ['BP', 'Stetho', 'Glucose'];
var user_id='0';
const BP = () => {
    const [newFlag,setNewFlag]=useState(false);
    const [bpList,setBPList]=useState([]);    
    const [bpstatus,setBPStatus]=useState("Click connect device");
    var external_id=0;

    useEffect(()=>{
      if (localStorage.getItem('user_info')!==null){
        //navigate('/Landing/tab1')
        var user_info=JSON.parse(localStorage.getItem('user_info'));
        external_id=user_info.phone;
        user_id=user_info.di_id.toString();        
        console.log("userid");
        console.log(user_id);
      }
      const headers = { headers: { "Content-Type": "application/json" } }
      const url = Api.FITNESS_API;
      const requestData = {
        task: 'getUserBP',
        external_id: external_id
      };
      axios.post(url,requestData,headers)
      .then(response=>{
        if (response.data.length > 0){
          const arr=[];
      //onLogin(username);
      //console.log(response.data)
      
      response.data.forEach(
          obj=>{
            //console.log(obj)
            //const arr=[...prescription_list];
            arr.push(obj['measurement_time']+' : '+obj['systolic']+'/'+obj['diastolic'])
            //prescription_list.push(obj['document_date']+','+obj['report_id']);
            //prescription_list.push('item')
          }
        );
        setBPList(arr)                
        }
      })
      .catch(error=>{
        console.log(error)
      });
    },[]);

    const previousBtn=()=>{
        setNewFlag(false);
    };
    const newRecordingBtn=()=>{
        setNewFlag(true);
    };

    useEffect(() => {
      // Only add listener on native platforms
      if (Capacitor.isNativePlatform() && BPPlugin) {
    BPPlugin.addListener('sembpmstatus', (info) => {
      setBPStatus(JSON.stringify(info));
      console.log('Received background task completion event: ', info);
    });
      }
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 p-4">
          {/* Platform Warning for Web */}
          {!Capacitor.isNativePlatform() && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <div className="flex items-center">
                <svg className="w-5 h-5 text-yellow-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <span className="text-yellow-800 font-medium">Web Platform</span>
              </div>
              <p className="text-yellow-700 text-sm mt-1">
                Blood Pressure device recording not available on web platform. Use the mobile app for recording.
              </p>
            </div>
          )}

          <div className="bg-white rounded-lg shadow-md p-6 mb-4">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Blood Pressure Monitor</h1>
            <div className="flex gap-4 mb-4">
              <button 
                onClick={previousBtn}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Previous Recordings
              </button>
              <button 
                onClick={newRecordingBtn}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                New Recording
              </button>
            </div>
          {!newFlag && <PreviousList bplist={bpList}/>}
          {newFlag && <NewRecording />}
            {Capacitor.isNativePlatform() && BPPlugin && (
              <p className="mt-4 text-gray-600">{bpstatus}</p>
            )}
          </div>
          <BottomTab />
        </div>
      );
    };

const PreviousList=({bplist}) =>{
    return (
        <div className="mt-4">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Previous Recordings</h2>
          {bplist.length === 0 ? (
            <p className="text-gray-500">No previous recordings found.</p>
          ) : (
            <ul className="space-y-2">
            {bplist.map((item, index) => (
                <li key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                  <p className="text-gray-700">{item}</p>
                </li>
            ))}
          </ul>
          )}
        </div>
      );
};

const NewRecording=()=>{
    const isWeb = !Capacitor.isNativePlatform();
    
    return(
    <div className="mt-4">
       <h2 className="text-xl font-semibold text-gray-900 mb-4">Start by clicking 'Connect Device'</h2>
       {isWeb ? (
         <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
           <p className="text-gray-600">Device connection is only available on mobile platforms.</p>
         </div>
       ) : (
         <div className="flex gap-4">
           <button 
             onClick={connectUSBDevice}
             className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
           >
             Connect Device
           </button>
           <button 
             onClick={recordBP}
             className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
           >
             Record
           </button>
           <button 
             onClick={() => uploadBP(user_id)}
             className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
           >
             Upload
           </button>
         </div>
       )}
    </div>
    );
};

const connectUSBDevice=()=>{
    if (Capacitor.isNativePlatform() && BPPlugin) {
    BPPlugin.connectUSB({ value: 'Connect device' }).then(result => {
      //console.log(result.message); // Log the result from the plugin
      //setText(result.message);
    });
    }
};

const recordBP=()=>{
  if (Capacitor.isNativePlatform() && BPPlugin) {
  BPPlugin.recordBP({ value: 'Record BP' }).then(result => {
    //console.log(result.message); // Log the result from the plugin
    //setText(result.message);
  });
  }
};

const uploadBP=(userid)=>{
  if (Capacitor.isNativePlatform() && BPPlugin) {
  console.log(userid)
  BPPlugin.uploadBP({ value: 'Upload BP',user_id:userid}).then(result => {
  });
  }
};



export default BP;